export async function exportVideo(canvas, wavesurfer, audioCtx, audioDest, duration, bgMedia, lyrics, styles) {
  return new Promise((resolve, reject) => {
    try {
      // 1. Setup streams
      const canvasStream = canvas.captureStream(60); // 60 FPS
      const audioStream = audioDest.stream;
      
      // Merge audio and video streams
      const tracks = [...canvasStream.getVideoTracks(), ...audioStream.getAudioTracks()];
      const mergedStream = new MediaStream(tracks);

      // 2. Setup MediaRecorder
      let mimeType = 'video/webm;codecs=vp9,opus';
      if (!MediaRecorder.isTypeSupported(mimeType)) {
        mimeType = 'video/webm;codecs=vp8,opus';
      }
      if (!MediaRecorder.isTypeSupported(mimeType)) {
        mimeType = 'video/webm';
      }

      const recorder = new MediaRecorder(mergedStream, {
        mimeType,
        videoBitsPerSecond: 8000000 // 8 Mbps for good quality
      });

      const chunks = [];
      recorder.ondataavailable = e => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `lyric_video_${Date.now()}.webm`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        resolve();
      };

      // 3. Play audio from the beginning and start recording
      wavesurfer.seekTo(0);
      
      setTimeout(() => {
        wavesurfer.play();
        recorder.start();
      }, 500);

      // Stop recording when audio finishes
      const onFinish = () => {
        if (recorder.state === 'recording') {
          recorder.stop();
        }
        wavesurfer.un('finish', onFinish);
      };
      
      wavesurfer.on('finish', onFinish);
      
      // Fallback timeout in case 'finish' event is missed
      setTimeout(() => {
        if (recorder.state === 'recording') {
           onFinish();
        }
      }, (duration + 2) * 1000);

    } catch (err) {
      reject(err);
    }
  });
}